import { Fuel, Package, Users, TrendingUp } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Dashboard() {
  const { user } = useAuth();

  return (
    <div data-testid="dashboard-page">
      {/* Page header */}
      <header className="bg-white border-b border-black/5 px-8 py-5">
        <h1 className="font-display text-xl font-semibold text-[#0A0A0A] tracking-tight">
          Dashboard
        </h1>
        <p className="text-xs text-[#525252] mt-0.5">
          Overview of the Sree LPG Fuel Access panel
        </p>
      </header>

      <div className="p-8">
        <div className="mb-8">
          <h2 className="font-display text-2xl sm:text-3xl font-semibold text-[#0A0A0A] tracking-tight">
            Welcome back, {user?.name || "Admin"}
          </h2>
          <p className="text-sm text-[#525252] mt-1">
            This is your command center. Modules will light up as they are built.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { icon: Fuel, label: "Active Cylinders", value: "—" },
            { icon: Package, label: "Deliveries Today", value: "—" },
            { icon: Users, label: "Customers", value: "—" },
            { icon: TrendingUp, label: "Revenue (MTD)", value: "—" },
          ].map(({ icon: Icon, label, value }, idx) => (
            <div
              key={label}
              className="bg-white border border-black/5 rounded-xl p-5 hover:shadow-[0_8px_24px_rgba(0,0,0,0.04)] transition-shadow"
              data-testid={`stat-card-${idx}`}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="w-9 h-9 rounded-lg bg-[#F50E02]/10 flex items-center justify-center">
                  <Icon className="h-4 w-4 text-[#F50E02]" />
                </div>
              </div>
              <p className="text-xs uppercase tracking-wider text-[#525252] font-semibold">
                {label}
              </p>
              <p className="font-display text-2xl font-semibold text-[#0A0A0A] mt-1">
                {value}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-white border border-black/5 rounded-xl p-8 text-center">
          <p className="text-sm text-[#525252]">
            Additional modules (orders, inventory, agents, reports) will appear here as they are built.
          </p>
        </div>
      </div>
    </div>
  );
}
